<div
  *ngIf="!fieldAttribute.hidden"
  [attr.data-test-id]="'wrap-' + fieldAttribute.elementDataTestId"
  [ngClass]="fieldAttribute.elementStyles.containerStyle"
  class="multiple-select-container"
>
  <label
    *ngIf="fieldAttribute.backendAttribute.label"
    [for]="fieldAttribute.id"
    class="form-label label"
    [ngClass]="fieldAttribute.elementStyles.labelStyle"
    (click)="$event.preventDefault()"
  >
    {{ fieldAttribute.backendAttribute.label | translate }}
    <span *ngIf="fieldAttribute.backendAttribute.required">*</span>
    <div
      *ngIf="isMobileView && isShowInfoTooltip"
      class="ms-1 custom-tooltip"
      data-test-id="info-tooltip"
      placement="bottom auto"
      [ngbTooltip]="fieldAttribute.backendAttribute.placeholder | translate"
      triggers="click:blur"
    >
      <img src="assets/icons/icon-info.svg" alt="info" />
    </div>
  </label>
  <div
    [class.disabled-control]="isControlDisabled()"
    [ngClass]="fieldAttribute.elementStyles.contentStyle"
    [class.is-invalid]="isMaxItems"
    [attr.data-test-id]="'container_' + fieldAttribute.elementDataTestId"
    class="d-flex flex-row flex-wrap"
  >
    <span class="btn btn-outline-secondary btn-sm selected" *ngFor="let item of selectedItems; index as i">
      <span class="no-linked-btn">
        {{ item }}
      </span>
      <span
        [attr.data-test-id]="fieldAttribute.elementDataTestId + '-item-' + i"
        class="close-selected"
        (click)="onCloseItem(item)"
      >
        <b>x</b>
      </span>
    </span>
    <input
      appToggleOverflow
      #multipleSearchInput
      multiple
      class="multiple-search-input"
      type="text"
      container="body"
      [attr.data-test-id]="fieldAttribute.elementDataTestId"
      [id]="fieldAttribute.id"
      [placeholder]="(isMobileView ? newPlaceholder : fieldAttribute.backendAttribute.placeholder) | translate"
      [attr.maxlength]="fieldAttribute.backendAttribute.max_length"
      [attr.minlength]="fieldAttribute.backendAttribute.min_length"
      (keyup)="onCheckAndSelectItem($event)"
      (blur)="onBlur($event.target['value'])"
      (input)="onValueChanged()"
    />
  </div>
  <div class="d-flex justify-content-between mt-1" data-test-id="comment-max-length-counter">
    <small *ngIf="isMaxItems" class="d-flex mt-1 invalid-feedback" data-test-id="error-max-length">
      {{ 'ALTERNATIVE_NAMES_ERROR' | translate: { count: maxLength } }}
    </small>
    <app-counter
      class="ms-auto"
      [maxLength]="maxLength"
      [isFieldInvalid]="isMaxItems"
      [dataTestId]="'max-length-counter'"
      [valueLength]="currentLength"
    >
    </app-counter>
  </div>
  <small
    *ngIf="form.get(fieldAttribute.backendAttribute.name) && form.get(fieldAttribute.backendAttribute.name).invalid"
    class="d-flex mt-1 invalid-feedback"
    [attr.data-test-id]="fieldAttribute.errorDataTestId"
  >
    {{ getValidationError(form.get(fieldAttribute.backendAttribute.name)) | translate }}
  </small>
</div>
